<template>
  <ConfigPage>
    <ConfigItem
      :title="__('Equipamento não enquadrado', 'settings')"
      :description="
        __(
          'O parâmetro define se o sistema permite mudança de status para concluídos ignorando equipamentos desenquadrados e não identificados',
          'settings'
        )
      "
    >
      <v-card class="mx-4" outlined>
        <v-card-text>
          <v-switch
            v-model="value"
            :label="__('Ignorar equipamento não enquadrado', 'settings')"
            @change="handleUpdateEnabled"
          ></v-switch>
        </v-card-text>
      </v-card>
    </ConfigItem>
  </ConfigPage>
</template>

<script>
import ConfigPage from "@/layouts/configs/ConfigPage";
import ConfigItem from "@/layouts/configs/ConfigItem";
import i18n from "@/mixins/i18n";
import { getParam, updateParam } from "@/services/configs/system_params";
import ToastsMixin from "@/mixins/ToastsMixin";

export default {
  mixins: [i18n, ToastsMixin],
  components: {
    ConfigPage,
    ConfigItem,
  },
  data() {
    return {
      value: false,
      loading: false,
    };
  },
  methods: {
    async handleUpdateEnabled(value) {
      try {
        await this.updateParam(value);
        this.toastSuccess(this.__("salvo", "settings"));
      } catch (error) {
        this.toastError(
          this.__("Não foi possível atualizar parâmetro", "settings")
        );
        this.value = !value;
      }
    },
    async loadParam() {
      this.loading = true;
      try {
        const { value } = await getParam("lead_ignore_non_compliant_equipment");
        this.value = value;
      } catch (error) {
        this.toastError(
          this.__("Não foi possível carregar parâmetro", "settings")
        );
      } finally {
        this.loading = false;
      }
    },
    updateParam(value) {
      return updateParam("lead_ignore_non_compliant_equipment", value);
    },
  },
  created() {
    this.loadParam();
  },
};
</script>
